export const IS_PRODUCTION = window.location.hostname === "app.futuremoney.co";

export const IS_LOCAL = window.location.hostname === "localhost";

const production = {
  env: "production",
  api: {
    url: "https://api.futuremoney.co",
  },
  intercom: {
    appId: "nb0m9tkr",
  },
  mixpanel: {
    // Session Replay only - events still flow through Segment. The project
    // token is a public client token like the Segment/Stytch ones above, but
    // it has never lived in this repo: mobile reads MIXPANEL_TOKEN from
    // Bitrise secrets. Until it is filled in, SessionReplay stays a no-op.
    token: "",
    // Mixpanel recommends starting at 100% to confirm capture is behaving,
    // then tuning down once replay volume is known.
    recordSessionsPercent: 100,
  },
  segment: {
    key: "OXxQ9UCbO00VMUKuzMUujzb0YyW5CbI1",
  },
  sentry: {
    dsn: "https://8fccc19df88ef8c030fc002b494d7610@o4505516861882368.ingest.us.sentry.io/4507993094160384",
  },
  store: {
    apple: "https://apps.apple.com/us/app/futuremoney/id6445875948",
    google: "https://play.google.com/store/apps/details?id=com.futuremoney.mobile&hl=en_CA",
  },
  stytch: {
    publicToken: "public-token-live-a5eb92aa-3349-4dff-a82e-856e5bbad879",
    loginRedirect: "https://app.futuremoney.co/oauth-callback",
    signUpRedirect: "https://app.futuremoney.co/oauth-callback",
  },
};

const development = {
  env: "development",
  api: {
    url: "https://api.dev.futuremoney.co",
  },
  intercom: {
    appId: "nb0m9tkr",
  },
  mixpanel: {
    // Session Replay only - events still flow through Segment. The project
    // token is a public client token like the Segment/Stytch ones above, but
    // it has never lived in this repo: mobile reads MIXPANEL_TOKEN from
    // Bitrise secrets. Until it is filled in, SessionReplay stays a no-op.
    token: "",
    // Mixpanel recommends starting at 100% to confirm capture is behaving,
    // then tuning down once replay volume is known.
    recordSessionsPercent: 100,
  },
  segment: {
    key: "TBqLA3GZBWxhbbOv3rdFVf8Z4O2QA1VJ",
  },
  sentry: {
    dsn: "https://8fccc19df88ef8c030fc002b494d7610@o4505516861882368.ingest.us.sentry.io/4507993094160384",
  },
  store: {
    apple: "https://apps.apple.com/us/app/futuremoney/id6445875948",
    google: "https://play.google.com/store/apps/details?id=com.futuremoney.mobile&hl=en_CA",
  },
  stytch: {
    publicToken: "public-token-test-ad228a3b-3f5c-4d92-91b6-3b60a65361cc",
    loginRedirect: "https://app.dev.futuremoney.co/oauth-callback",
    signUpRedirect: "https://app.dev.futuremoney.co/oauth-callback",
  },
};

const base = IS_PRODUCTION ? production : development;

export const environment = {
  ...base,
  api: { ...base.api, url: import.meta.env.VITE_API_URL ?? base.api.url },
  mixpanel: {
    ...base.mixpanel,
    token: import.meta.env.VITE_MIXPANEL_TOKEN ?? base.mixpanel.token,
    // Replays are off on localhost so day-to-day development does not burn
    // replay quota. Setting the token explicitly in .env.local opts back in,
    // which is the only way to verify a Session Replay change before it ships.
    recordLocally: Boolean(import.meta.env.VITE_MIXPANEL_TOKEN),
  },
  segment: { ...base.segment, key: import.meta.env.VITE_SEGMENT_KEY ?? base.segment.key },
  stytch: {
    ...base.stytch,
    publicToken: import.meta.env.VITE_STYTCH_PUBLIC_TOKEN ?? base.stytch.publicToken,
    loginRedirect: import.meta.env.VITE_STYTCH_LOGIN_REDIRECT ?? base.stytch.loginRedirect,
    signUpRedirect: import.meta.env.VITE_STYTCH_SIGNUP_REDIRECT ?? base.stytch.signUpRedirect,
  },
};
